import { createRoute } from '@tanstack/react-router'

import { SpecimenList } from '../../collections/specimen-list.js'
import { TreeManager } from '../../collections/tree-manager.js'
import { settingsRoute } from './layout.js'

export const locationsRoute = createRoute({
  getParentRoute: () => settingsRoute,
  path: 'locations',
  component: () => (
    <TreeManager
      kind="locations"
      details={(node) => <SpecimenList query={{ locationId: node.id }} />}
    />
  ),
})
